import { combineReducers } from 'redux';
import alert from './alerts';
import user from './user';
import promo from './promo';
import library from './library';
import brands from './brands';
import categories from './categories';
import products from './products';
import store_configs from './store_configs';
import marketing_rules from './marketing_rules';
import admin from './admin';
import email from './email';
import ui from './ui';
import sales from './sales';
import store_pickup from './store_pickup';
import bluepay from './bluepay';
import audit_logs from './audit_logs';
import customers from './customers';
import coupon_rules from './coupon_rules';
import cms_pages from './cms_pages';
import cms_blocks from './cms_blocks';
import general from './general';
import banner_manager from './banner_manager';
import referral_program from './referral_program';
import partners from './partners';
import stripe from './stripe';
import home from './home';
import help from './help';
import asset_manager from './asset_manager';
import styles_palette from './styles_palette';
import dns_manager from './dns_manager';
import buttons_configs from './buttons_configs';
import tax_rates from './tax_rates';
import subscription from './subscription';
import store_orders from './store_orders';
import quote from './quote';
import store_emails from './store_emails';
import eavAttributes from './eavAttributes';
import customer_subscriptions from './customer_subscriptions';
import deposits from './deposits';
import gift_card from './gift_card';
import rpa from './rpa';
import sync_logs from './sync_logs';
import dataDictionary from './dataDictionary';
import quote_marketing_segments from './quote_marketing_segments';
import aestheticKpiWarehouse from './aestheticKpiWarehouse';
import automatedQuotes from './automated_quotes';
import bulk_price from './bulk_price';


export const reducers = combineReducers({
  admin,
  aestheticKpiWarehouse,
  alert,
  asset_manager,
  audit_logs,
  automatedQuotes,
  banner_manager,
  bluepay,
  brands,
  bulk_price,
  buttons_configs,
  categories,
  cms_blocks,
  cms_pages,
  coupon_rules,
  customers,
  customer_subscriptions,
  dataDictionary,
  deposits,
  dns_manager,
  email,
  eavAttributes,
  general,
  gift_card,
  help,
  home,
  library,
  marketing_rules,
  partners,
  products,
  promo,
  quote,
  quote_marketing_segments,
  referral_program,
  rpa,
  sales,
  store_configs,
  store_emails,
  store_orders,
  store_pickup,
  stripe,
  styles_palette,
  subscription,
  tax_rates,
  ui,
  user,
  sync_logs
});
